export default __webpack_public_path__ + "static/media/FULLSOON_LOGO.f3485a9a.svg";